import React, { memo } from 'react';
import UIProgressBar from 'Components/UIComponents/UIProgressBar';

interface InteractPreparingProps {
  count: number;
  total: number;
}

const InteractPreparing = ({ count, total }: InteractPreparingProps) => (
  <div className="interactModal__fieldBar-progressWrapper">
    <div className="interactModal__fieldBar-progressInfo">
      <p className="interactModal__fieldBar-progressInfo-title">Loading pages</p>
      <p className="interactModal__fieldBar-progressInfo-count">
        {`${count} / ${total}`}
      </p>
    </div>
    <UIProgressBar percent={(count / total) * 100} />
  </div>
);

InteractPreparing.displayName = InteractPreparing.name;

export default memo(InteractPreparing);
